import LayoutTwo from "../../layouts/LayoutTwo";
import SEO from "../../components/seo";
import successImg from "../../assets/images/Others/order-success.png";
import { Link } from "react-router-dom"

const OrderSuccess = () => {
  return (
    <>
      <SEO titleTemplate="Shop Page" description="Shop page" />
      <LayoutTwo>
        <section className="order_success_page">
          <img src={successImg} alt="Order success" className="success_img" />
          <h6>Success</h6>
          <p>
            Order placed successfully. Kindly check your order book to view
            status
          </p>
          <Link className="button primary_btn" to="/order/2">
            View Order
          </Link>
          <Link to="/">Continue to Site</Link>
        </section>
      </LayoutTwo>
    </>
  );
};

export default OrderSuccess;
